export default __webpack_public_path__ + "static/media/plain-sticker-os.22ab5b01.png";